"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobOfferSchema = void 0;
const zod_1 = require("zod");
const job_enum_1 = require("./job.enum");
exports.JobOfferSchema = zod_1.z.object({
    id: zod_1.z.string(),
    candidateId: zod_1.z.string(),
    jobId: zod_1.z.string(),
    offerById: zod_1.z.string(),
    status: job_enum_1.JobOfferStatusEnum,
    cancelledAt: zod_1.z.string().datetime().nullish(),
    content: zod_1.z.string(),
    expiresAt: zod_1.z.string().datetime().nullish(),
    issuedAt: zod_1.z.string().datetime(),
    reason: zod_1.z.string().nullish(),
    scheduledAt: zod_1.z.string().datetime().nullish(),
    sentAt: zod_1.z.string().datetime().nullish(),
    title: zod_1.z.string(),
    isCasualInterviewOK: zod_1.z.boolean(),
    isDeletedByCandidate: zod_1.z.boolean(),
    isFirstInterviewExempt: zod_1.z.boolean(),
    isFirstSecondInterviewExempt: zod_1.z.boolean(),
    isNoReasonToEntryOK: zod_1.z.boolean(),
    isPremiumOffer: zod_1.z.boolean(),
    isPreviousJobSalaryGuaranteed: zod_1.z.boolean(),
    isResumeScreeningExempt: zod_1.z.boolean(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
});
